import { CommonModule } from '@angular/common';
import { WHATSAPP } from '../../../constants/whatsapp';
import { Component, inject } from '@angular/core';
import {
  LucideAngularModule,
  PhoneIcon,
  MessageCircleIcon,
  ZapIcon,
} from 'lucide-angular';
import { UserMenuComponent } from '../../auth/user-menu/user-menu';
import { StoreService } from '../../../services/store.service';
import { Sucursal } from '../../../types/stores';
import { toSignal } from '@angular/core/rxjs-interop';
import { DialogModule } from 'primeng/dialog';
import { MiTienda } from '../../sucursales/mi-tienda/mi-tienda';

@Component({
  selector: 'allas-top-bar',

  imports: [
    CommonModule,
    LucideAngularModule,
    UserMenuComponent,
    DialogModule,
    MiTienda,
  ],
  templateUrl: 'top-bar.html',
})
export class TopBarComponent {
  readonly whatsapp = WHATSAPP;
  private storeService = inject(StoreService);
  readonly phoneIcon = PhoneIcon;
  readonly messageCircleIcon = MessageCircleIcon;
  readonly zapIcon = ZapIcon;

  readonly selectedStore = toSignal(this.storeService.selectedStore$, {
    initialValue: null,
  });

  showStoreDialog = false;
  pendingCall = false; // Flag para indicar que se debe hacer una llamada después de seleccionar

  handlePhoneClick(event: Event): void {
    const store = this.selectedStore();
    if (!store || !store.phone) {
      // No hay sucursal seleccionada, abrir el diálogo
      this.pendingCall = true; // Marcar que se debe hacer llamada después de seleccionar
      this.showStoreDialog = true;
      event.preventDefault();
      event.stopPropagation();
    } else {
      // Hay sucursal seleccionada, dejar que el enlace funcione normalmente
      // No prevenir el comportamiento por defecto
    }
  }

  handleStoreSelect(store: Sucursal): void {
    this.showStoreDialog = false;
    
    // Si se marcó que se debe hacer una llamada, hacerla ahora
    if (this.pendingCall && store.phone) {
      this.pendingCall = false;
      // Usar setTimeout para asegurar que el diálogo se cierre primero
      setTimeout(() => {
        // Usar window.location para iniciar la llamada (más confiable en móviles)
        window.location.href = `tel:+504${store.phone}`;
      }, 100);
    }
  }

  handleDialogClose(): void {
    this.showStoreDialog = false;
    this.pendingCall = false;
  }
}
